import React from "react";
import { DOMAIN } from "../../utilities/consts";
import ScanView from "./ScanView";

// import MediaCard from "./../../components/MediaCard/MediaCard";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getScanData,
  downloadScanXls,
  getScanRanges
} from "../../modules/scan";
import { changeSelectedUnits } from "./../../modules/units";
import { changeTitle } from "../../modules/navigation";
import hasTP from "./../../utilities/unitsFilters";

class Scan extends React.Component {
  constructor() {
    super();
    this.state = {
      alertMessage: "",
      isAlertMessageOpen: false,
      dtcRequest: false,
      selectedRanges: {
        engineSpeed: { value: 1000, active: false },
        antifreezeTemperature: { value: 100, active: false },
        throttlePosition: { value: 40, active: false },
        odometer: { value: 25, active: false },
        hourmeter: { value: 1, active: false },
        fuelLevel: { value: 5, active: false }
      },
      chartCardsValues: {
        throttlePosition: 20,
        vehicleSpeed: 0,
        engineSpeed: 0,
        antifreezeTemperature: 40
      }
    };
  }

  componentDidMount() {
    this.props.changeTitle("Scan");
  }

  componentWillReceiveProps(nextProps) {}

  fetchData = () => {
    const { lang } = this.props;
    const config = {
      unidades: this.props.selectedUnits,
      fechaInicial: this.props.startDate._d.getTime(),
      fechaFinal: this.props.endDate._d.getTime(),
      zona: this.props.zone,
      unidadTemperatura: this.props.temperatureUnit,
      unidadMetrica: "km"
    };

    if (config.unidades.length === 0) {
      this.openAlertMessage(lang.SeleccioneAlMenosUnaUnidad);
      return;
    }
    this.props.getScanData(config);
  };

  openConfiguration = () => {
    this.setState({ isConfigOpen: true });
  };

  closeConfiguration = () => {
    this.setState({ isConfigOpen: false });
  };

  toggleDtcRequest = () => {
    const { dtcRequest } = this.state;
    this.props.changeSelectedUnits([], false);
    this.setState({
      dtcRequest: !dtcRequest
    });
  };

  scanChartCursorCallback = value => {
    console.log(value);
    this.setState({
      chartCardsValues: {
        throttlePosition: value.PosicionAcelerador
          ? value.PosicionAcelerador
          : this.state.chartCardsValues.throttlePosition
      }
    });
  };

  saveConfiguration = () => {};

  onChangeRangesInputs = e => {
    const id = e.target.id;
    const value = e.target.value;

    this.setState({
      selectedRanges: {
        ...this.state.selectedRanges,
        [id]: { value: value, active: this.state.selectedRanges[id].active }
      }
    });
  };

  openAlertMessage = msg => {
    this.setState({ alertMessage: msg, isAlertMessageOpen: true });
  };

  handleCloseAlertMessage = () => {
    this.setState({
      isAlertMessageOpen: false,
      message: ""
    });
  };

  onChangeRangesCheck = e => {
    const id = e.target.id;
    const value = e.target.checked;
    console.log(value);

    this.setState({
      selectedRanges: {
        ...this.state.selectedRanges,
        [id]: { active: value, value: this.state.selectedRanges[id].value }
      }
    });
  };

  downloadScanXls = () => {
    const fechaInicial = this.props.startDate.valueOf(),
      fechaFinal = this.props.endDate.valueOf(),
      lang = this.props.lang._code === "en" ? "en-US" : "es-MX",
      unidades = this.props.selectedUnits,
      zona = this.props.zone;

    window.open(
      `${DOMAIN}/GenerarReporte.aspx?sTipoReporte=scan&fInicial=${fechaInicial}&fFinal=${fechaFinal}&aUnidades=${unidades}&zona=${zona}&lang=${lang}`,
      "_blank"
    );
  };

  downloadScanPdf = () => {};

  render() {
    return (
      <ScanView
        {...this.props}
        closeConfiguration={this.closeConfiguration}
        openConfiguration={this.openConfiguration}
        downloadScanPdf={this.downloadScanPdf}
        downloadScanXls={this.downloadScanXls}
        alertMessage={this.state.alertMessage}
        isAlertMessageOpen={this.state.isAlertMessageOpen}
        isConfigOpen={this.state.isConfigOpen}
        fetchData={this.fetchData}
        dtcRequest={this.state.dtcRequest}
        toggleDtcRequest={this.toggleDtcRequest}
        selectedRanges={this.state.selectedRanges}
        onChangeRangesInputs={this.onChangeRangesInputs}
        onChangeRangesCheck={this.onChangeRangesCheck}
        chartCardsValues={this.state.chartCardsValues}
        scanChartCursorCallback={this.scanChartCursorCallback}
        downloadExcel={this.downloadScanXls}
        openAlertMessage={this.openAlertMessage}
        handleCloseAlertMessage={this.handleCloseAlertMessage}
      />
    );
  }
}

const mapStateToProps = state => {
  let units = state.units.data.filter(v => hasTP(v, [".can"]));
  // let ranges = units.reduce(u => {
  //   let unitRanges = {};
  // });

  console.log(state.scan.ranges);

  const selectedTags = state.units.selectedTags;
  if (selectedTags.length > 0)
    units = units.filter(unit => {
      let unitTags = unit.Etiquetas.split(",").filter(t => t !== "");
      return (
        unitTags.filter(ut => {
          return selectedTags.includes(ut);
        }).length > 0
      );
    });

  let ranges = state.scan.ranges;
  units = units.map(u => {
    if (ranges.filter(r => r.Unidad === u.Unidad).length > 0) {
      return {
        ...u,
        RPM: ranges
          .filter(r => r.Unidad === u.Unidad)[0]
          .Rangos.filter(r => r.Nombre == "RPM")[0].Valor,
        Odometro: ranges
          .filter(r => r.Unidad === u.Unidad)[0]
          .Rangos.filter(r => r.Nombre == "Odometro")[0].Valor,
        PorcentajeCombustible: ranges
          .filter(r => r.Unidad === u.Unidad)[0]
          .Rangos.filter(r => r.Nombre == "PorcentajeCombustible")[0].Valor,
        TemperaturaAnticongelante: ranges
          .filter(r => r.Unidad === u.Unidad)[0]
          .Rangos.filter(r => r.Nombre == "TemperaturaAnticongelante")[0].Valor,
        Horometro: ranges
          .filter(r => r.Unidad === u.Unidad)[0]
          .Rangos.filter(r => r.Nombre == "Horometro")[0].Valor,
        PosicionAcelerador: ranges
          .filter(r => r.Unidad === u.Unidad)[0]
          .Rangos.filter(r => r.Nombre == "PosicionAcelerador")[0].Valor
      };
    } else {
      return u;
    }
  });

  console.log(units);

  return {
    selectedUnits: state.units.selectedUnits,
    permissions: state.permissions.data,
    loadedPermissions: state.permissions.loadedPermissions,
    startDate: state.dates.startDate,
    endDate: state.dates.endDate,
    zone: state.dates.zone,
    reportData: state.scan.data,
    isLoading: state.scan.isLoading,
    hasData: state.scan.hasData,
    lang: state.internationalization.lang,
    units,
    permissions: state.permissions.data,
    loadedPermissions: state.permissions.loadedPermissions,
    temperatureUnit: state.internationalization.temperatureUnit
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getScanData,
      downloadScanXls,
      changeTitle,
      changeSelectedUnits,
      getScanRanges
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Scan);



// WEBPACK FOOTER //
// ./src/containers/Scan/Scan.js